import { inject } from '@angular/core';
import { RedirectCommand, ResolveFn, Router } from '@angular/router';
import { catchError, map, of } from 'rxjs';
import { SecureUploadService } from '../../services/secure-upload.service';

/**
 * Backward-compatibility entry point for legacy FormGenerator MVC links of the shape
 * `/SecureUpload/External/{secureUploadIdentifier}` (emailed to external users and hardcoded
 * in Portal / Signing / SupportTool). Resolves the identifier to a formId and redirects to the
 * new SPA-style `secureupload/:formId` route. Runs as a route resolver so no component renders.
 */
export const secureUploadExternalResolver: ResolveFn<RedirectCommand> = route => {
  const router = inject(Router);
  const notFound = new RedirectCommand(router.parseUrl('/form/not-found'), { replaceUrl: true });

  const identifier = route.paramMap.get('secureUploadIdentifier');
  if (!identifier) {
    return notFound;
  }

  return inject(SecureUploadService)
    .resolveExternal(identifier)
    .pipe(
      map(
        ({ formId }) =>
          new RedirectCommand(router.parseUrl(`/secureupload/${formId}`), { replaceUrl: true }),
      ),
      catchError(() => of(notFound)),
    );
};
